import { Box } from '@mui/material';
import { RenderTable } from '../../../../../../components/ui';
import TBody from './TBody';
import THead from './THead';
interface IProps {
  moduleData: any;
}

const TController = ({ moduleData }: IProps) => {
  return (
    <Box>
      <RenderTable>
        <THead  />
        <TBody {...{ moduleData }} />
      </RenderTable>
    </Box>
  );
};

export default TController;
